<template>
  <div class="rescue-confirmation-page">
    <h1>Success!</h1>
    <p>You are now on our $19.99/month plan.</p>
    <p>That's amazing.</p>

    <cta-button
      type="button"
      class="button"
      :disabled="isLoading"
      @click="navToSubscriptionPage()"
      >Thanks!</cta-button
    >
  </div>
</template>

<script>
import CtaButton from "@/components/CtaButton";

export default {
  name: "RescueConfirmationPage",
  components: {
    CtaButton,
  },
  data() {
    return {
      isLoading: false,
      error: null,
    };
  },
  methods: {
    navToSubscriptionPage() {
      this.$router.push({ name: "subscription" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/variables";
@import "@/style/mixins";

.rescue-confirmation-page {
}
</style>
